<template>
  <svg :width="width" :height="height"
      xmlns:dc="http://purl.org/dc/elements/1.1/"
      xmlns:cc="http://creativecommons.org/ns#"
      xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"
      xmlns:svg="http://www.w3.org/2000/svg"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd"
      xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape"
      viewBox="0 0 300 300"
      id="svg2"
      version="1.1"
      inkscape:version="0.91 r13725"
      sodipodi:docname="3dprinteros_icon_catia.svg">
    <metadata
        id="metadata30">
      <rdf:RDF>
        <cc:Work
            rdf:about="">
          <dc:format>image/svg+xml</dc:format>
          <dc:type
              rdf:resource="http://purl.org/dc/dcmitype/StillImage" />
          <dc:title></dc:title>
        </cc:Work>
      </rdf:RDF>
    </metadata>
    <defs
        id="defs28">
      <pattern
          y="0"
          x="0"
          height="6"
          width="6"
          patternUnits="userSpaceOnUse"
          id="EMFhbasepattern" />
    </defs>
    <sodipodi:namedview
        pagecolor="#ffffff"
        bordercolor="#666666"
        borderopacity="1"
        objecttolerance="10"
        gridtolerance="10"
        guidetolerance="10"
        inkscape:pageopacity="0"
        inkscape:pageshadow="2"
        inkscape:window-width="1957"
        inkscape:window-height="867"
        id="namedview26"
        showgrid="false"
        inkscape:zoom="0.78666667"
        inkscape:cx="-8.2627119"
        inkscape:cy="150"
        inkscape:window-x="0"
        inkscape:window-y="0"
        inkscape:window-maximized="0"
        inkscape:current-layer="svg2" />
    <path
        d="m 150.00022,-8.10489e-6 c 82.84289,0 149.99983,67.15728910489 149.99983,150.00016810489 0,82.84287 -67.15694,149.99984 -149.99983,149.99984 -82.842882,0 -150.00017737106,-67.15694 -150.00017737106,-149.99984 0,-82.842849 67.15729537106,-150.00016810489 150.00017737106,-150.00016810489"
        style="fill:#f5f5f5;fill-rule:evenodd"
        id="path8"
        inkscape:connector-curvature="0" />
    <g
        id="g4195"
        transform="translate(-6.3558612,2.6211057)">
      <path
          style="fill:#584b4c;fill-opacity:1;fill-rule:evenodd;stroke:none"
          d="m 205.02491,166.19798 c 1.62021,0 9.1427,0.23167 10.41564,-0.11584 1.38877,-0.34867 3.47188,-3.82889 5.09209,-5.68542 4.16633,-5.1053 10.06848,-3.24877 17.47512,-3.94496 l -0.57918,-5.68542 -8.91115,-0.11583 c 0.80971,-1.50844 9.14271,-12.06702 10.29992,-12.99534 l 4.28205,28.4272 10.64708,0.11584 c -2.0831,-8.47015 -3.00899,-17.75255 -4.39777,-26.57068 -1.50449,-9.86251 -0.34751,-11.02286 -4.16621,-11.02286 -5.43926,0 -8.10109,-0.92785 -9.83703,1.39237 -0.69386,0.92786 -1.15721,1.2763 -1.85166,2.2045 -6.13359,7.54195 -15.8549,18.10064 -21.29416,25.17843 -1.38878,1.85652 -6.48088,7.42587 -7.17521,8.81824 z"
          id="path4175"
          inkscape:connector-curvature="0" />
      <path
          style="fill:#584b4c;fill-opacity:1;fill-rule:evenodd;stroke:none"
          d="m 96.239069,166.19798 10.878521,0 c 2.66183,-2.9008 4.51349,-6.61363 7.75393,-8.23813 4.05049,-2.08843 9.48975,-1.0437 14.35041,-1.50832 l -0.57803,-5.56946 -8.79542,-0.23168 c 0.57918,-1.50843 3.81904,-5.1053 4.97626,-6.61374 1.04138,-1.27629 1.62022,-1.97248 2.5461,-3.24877 0.92555,-1.0437 1.62022,-2.43664 2.77744,-3.13283 l 4.28205,28.42721 10.06847,0.11583 -5.55498,-37.59353 c -3.009,0 -7.40677,-0.23168 -10.06848,0 -1.85166,0.11583 -1.96738,0.92786 -2.77755,2.08855 -3.35616,4.29305 -29.163811,33.76441 -29.858141,35.50498 z"
          id="path4177"
          inkscape:connector-curvature="0" />
      <path
          style="fill:#584b4c;fill-opacity:1;fill-rule:evenodd;stroke:none"
          d="m 94.850289,158.54008 c -5.90215,1.27641 -12.7303,3.01664 -18.86401,1.16034 -10.6472,-3.24889 -6.48087,-18.5648 6.48088,-23.78606 2.66171,-1.04485 5.67082,-1.6245 8.79553,-1.6245 4.39777,0.11584 6.36515,1.6245 9.374031,1.85653 1.15722,-2.32069 3.70344,-3.94508 4.51349,-6.14958 -9.952751,-2.32057 -16.780791,-3.71294 -28.006601,0.69618 -7.17531,2.78473 -14.00335,8.93431 -16.66507,16.01209 -7.05959,18.56481 12.15158,21.69763 25.22905,19.72504 4.16633,-0.69619 3.24055,-0.58035 5.32366,-3.01687 1.38877,-1.62439 2.77743,-3.01676 3.81904,-4.87317 z"
          id="path4179"
          inkscape:connector-curvature="0" />
      <path
          style="fill:#584b4c;fill-opacity:1;fill-rule:evenodd;stroke:none"
          d="m 150.51609,135.10211 14.81341,0 -10.41564,30.9798 10.06836,0.11584 10.76292,-30.9798 11.34176,-0.11584 c 0.8097,-0.92786 4.62921,-5.45339 4.86065,-6.49767 l -39.00107,0 z"
          id="path4181"
          inkscape:connector-curvature="0" />
      <path
          style="fill:#584b4c;fill-opacity:1;fill-rule:evenodd;stroke:none"
          d="m 186.50829,166.19798 10.06836,0 13.30891,-37.47747 -10.06847,-0.11584 z"
          id="path4183"
          inkscape:connector-curvature="0" />
    </g>
  </svg>

</template>

<script>
  export default {
    props: {
      width: {
        type: [Number, String],
        default: 300
      },
      height: {
        type: [Number, String],
        default: 300
      }
    }
  }
</script>